const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

const camelize = string =>
  string
    .split('_')
    .map((subString, index) =>
      index === 0 ? subString : capitalize(subString)
    )
    .join('');

const camelcaseKeys = obj => {
  if (obj && typeof obj === 'object') {
    let result = {};
    Object.keys(obj).forEach(key => {
      result[camelize(key)] = camelcaseKeys(obj[key]);
    });
    return result;
  } else {
    return obj;
  }
};

module.exports = camelcaseKeys;
